import { atomWithKey as atom } from './atomWithKey';
import { IBestPricePrices, ICalendarState, ISelectedCalenderDatePrice, ISelectedDisabledCalenderDate } from '../Types/Index';

export const calendarStateAtom = atom<ICalendarState>({
    key: 'calendarStateAtom',
    default: {
        selectedDates: [null, null],
        isFilled: false,
    },
});

export const calendarBestPriceAtom = atom<IBestPricePrices[]>({
    key: 'calendarBestPriceAtom',
    default: []
});

export const offerCalendarBestPriceAtom = atom<IBestPricePrices[]>({
    key: 'offerCalendarBestPriceAtom',
    default: []
});

export const markSelectedDateAsDisableAtom = atom<ISelectedDisabledCalenderDate>({
    key: 'markSelectedDateAsDisableAtom',
    default: {
        OUT_BOUND: [],
        IN_BOUND: []
    }
});
export const markSelectedDateAsSoldOutAtom = atom<ISelectedDisabledCalenderDate>({
    key: 'markSelectedDateAsSoldOutAtom',
    default: {
        OUT_BOUND: [],
        IN_BOUND: []
    }
});

export const dateSelectedFromCalendarAtom = atom<boolean>({
    key: 'dateSelectedFromCalendarAtom',
    default: false
});
export const isDateOfferCheckDoneAtom = atom<{
    OUT_BOUND: boolean,
    IN_BOUND: boolean
}>({
    key: 'isDateOfferCheckDoneAtom',
    default: {
        OUT_BOUND: false,
        IN_BOUND: false
    }
});
export const selectedDatePriceAtom = atom<ISelectedCalenderDatePrice[]>({
    key: 'selectedDatePriceAtom',
    default: []
});

export const calendarRangeBestPriceAtom = atom<IBestPricePrices[]>({
    key: 'calendarRangeBestPriceAtom',
    default: []
});


export const popularTripsPriceAtom = atom<any>({
    key: 'popularTripsPriceAtom',
    default: []
});
